import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByWeekComponent } from './recurring-by-week.component';

@NgModule({
	imports: [
		ComboComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByWeekComponent),
		InputComponentModule,
		SignpostComponentModule,
		TextComponentModule,
	],
	declarations: [
		RecurringByWeekComponent
	],
	exports: [RecurringByWeekComponent]
})
export class RecurringByWeekModule { }
